import { render, staticRenderFns } from "./Payroll.vue?vue&type=template&id=a6848232&scoped=true&"
import script from "./Payroll.vue?vue&type=script&lang=js&"
export * from "./Payroll.vue?vue&type=script&lang=js&"
import style0 from "./Payroll.vue?vue&type=style&index=0&id=a6848232&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6848232",
  null
  
)

export default component.exports